<template>
    <div class="ui segment">
        <div class="left floated">
            <h2
                style="display:inline-block; margin-bottom: 0;">
                <span class="title_number" style="position: relative;">
                    <span class="pointer" @click="show_core_wabill()"
                        :style="{fontSize: (style.width < 360) ? '20px' : ''}"
                        >
                        {{ core_waybill.number }}
                    </span>

                    <span class="copy_span" v-if="core_waybill.identity">
                        <span class="pointer" @click="$bus.$emit(eventbus.copy_field.name, 'number')">
                            <i class="circular inverted tiny copy icon z-depth-2">
                            </i>
                        </span>
                    </span>
                </span>
                <span
                    style="font-size: small;"
                    v-if="core_waybill.material">
                    <span class="title_number" style="position: relative;">
                        [{{ core_waybill.material.name }}]

                        <span
                            v-if="core_waybill.source_core_waybill"
                            class="have_source_core_waybill_warning pointer"
                        >
                            <span
                                @click="show_core_wabill(core_waybill.source_core_waybill.identity)"
                                :data-tooltip="$t('ui.toolbox.core_waybill.helps.tooltip_have_source_core_waybill', {
                                    'number': core_waybill.source_core_waybill.number
                                })"
                            >
                                <i class="red warning sign large icon"></i>
                            </span>
                        </span>
                    </span>

                </span>
            </h2>
            <div class="sub_content">
                <span class="operation_number" v-if="core_waybill.operation">
                    {{ $t('models.operations') }}：{{ core_waybill.operation.number }}
                </span>
                <span class="timestamp_content"
                    :class="[timestamp_content_color]">
                    {{ relative_time_text }}
                </span>
            </div>
        </div>

        <div class="right floated"
            style="margin-right: 8rem;"
            v-if="eventbus.file_uploader.name && $parent.is_can_update_field('receipt_file_url')">
            <FileUploader
                :channel="eventbus.file_uploader.name">
            </FileUploader>
        </div>

        <StatusesLabel
            v-if="is_initialized"
            :core_waybill="core_waybill"
            :statuses="statuses"
            >
        </StatusesLabel>

        <div class="clear">
        </div>
    </div>
</template>

<script>
import FileUploader from "@toolbox/file_uploader/main.vue"
import LabelInputItem from './label_input_item.vue'
import StatusesLabel from './statuses_label.vue'

export default {
    components: {
        FileUploader,
        StatusesLabel,
        LabelInputItem,
    },
    props: {
        core_waybill: {
            default: {},
            type: Object
        },
        statuses: {
            default: () => { return [] },
            type: Array
        },
        eventbus: {
            default: {
                change_current_template: {
                    name: "",
                },
                file_uploader: {
                    name: "",
                },
                update_core_waybill: {
                    name: "",
                },
                print_label: {
                    name: "",
                },
            },
            type: Object,
        },
        is_show_note: {
            default: false,
            type: Boolean
        },
        active_button_to_detail_route_name: {
            default: "",
            type: String
        },
    },
    data() {
        return {
            is_initialized: false,
            operator_last_statuses: {},
            relative_time_text: '幾秒前',
            timestamp_content_color: "",
        }
    },
    computed: {
        style() {
            return this.$store.state.style
        },
    },
    watch: {
        'core_waybill.number': {
            deep: true,
            handler(value) {
                this.init()
            }
        },
    },
    mounted() {
        this.init()
    },
    methods: {
        async init() {
            await new Promise(resolve => {
                this.relative_time_text = this.human_datetime(this.core_waybill.created_at, null, "relative")

                if (this.$moment().diff(this.core_waybill.created_at, "hours") < 1) {
                    this.timestamp_content_color = "red"
                } else if (this.$moment().diff(this.core_waybill.created_at, "hours") < 24) {
                    this.timestamp_content_color = "orange"
                }
                resolve()
            })
            await new Promise(resolve => {
                this.is_initialized = true
                resolve()
            })
        },
        show_core_wabill(identity = null) {
            try {
                if (!this.core_waybill.identity) {
                    throw "請輸入號碼"
                }

                if (
                    this.active_button_to_detail_route_name != "" &&
                    (
                        this.$route.name != 'edit_core_waybill' ||
                        this.$route.name != 'customer_show_core_waybill'
                    )
                ) {
                    this.$router.push({
                        name: this.active_button_to_detail_route_name,
                        params: {
                            identity: (identity) ? identity : this.core_waybill.identity
                        }
                    })
                } else {
                    var next_name = (this.eventbus.change_current_template.value == 'min_card') ? 'card' : 'detail'
                    this.$bus.$emit(this.eventbus.change_current_template.name, next_name)
                }

            } catch (err) {
                this.$noty.error(err)

            }
        },
        /*
         * ========================================================================
         * $parent
         * ========================================================================
         */
        is_can_update_field(field_name = "") {
            return this.$parent.is_can_update_field(field_name)
        },
    },
}
</script>

<style lang="scss" scoped>
.title_number:hover {
    & {
        position: relative;
    }
    .copy_span {
        display: block;
    }
}
.copy_span {
    display: none;
    position: absolute;
    top: -28px;
    right: -12px;
}
[data-tooltip]:not([data-position]):before {
    display: none;
}

.newline_original_number {
    font-size: small;
    font-weight: bold;
}

.have_source_core_waybill_warning {
    position: absolute;
    top: -28px;
    right: -14px;
}

.sub_content {
    margin: -9px 0px;
    font-size: 12px;
    color: #757575;
}
.sub_content .operation_number::after {
    content: "\0000b7";
    margin-left: 5px;
    margin-right: 5px;
}
.sub_content .timestamp_content {
    &.red {
        color: #d01919;
    }
    &.orange {
        color: #f2711c;
    }
    &.teal {
        color: #009c95;
    }
    &.purple {
        color: #a333c8;
    }
}
</style>
